<template>
  <div class="text-container">
    <el-tabs
      :tab-position="tabPosition"
      v-model="tabName"
      @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, ind) in tabList"
        :key="ind"
        :label="item.name"
        :name="item.id">
        <div class="box-container">
          <tab-content :classId="item.id" :ref="'tab' + item.id" />
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="to-top" v-show="showTop" @click="toTop">
      <img src="../../assets/image/to-top.png" alt="回到顶部" />
    </div>
  </div>
</template>

<script>
// import TabContent from './components/tabContent'
import TabContent from '@/views/publicInformationList/index.vue'
export default {
  name: 'CareerMatrix',
  components: {
    TabContent
  },
  data() {
    return {
      tabPosition: 'left',
      tabList: [
        { id: '6', name: '网络主播' },
        { id: '7', name: '全媒体运营师' },
        { id: '8', name: '网络信息审核员' },
        { id: '20', name: 'AIGC视听创制师' }
      ],
      tabName: '',
      showTop: false
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    }
  },
  watch: {
    '$route'(to) {
      if (to.name === 'CareerMatrix') {
        const obj = this.tabList[+to.params.type - 1]
        this.$refs['tab' + obj.id][0].getPublicList()
      }
    }
  },
  mounted() {
    if (this.type) {
      this.tabName = this.type
      this.$refs['tab' + Number(this.type) - 1][0].getPublicList()
    }
    this.listenerFunction()
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.listenerFunction)
  },
  methods: {
    // 监听滚动条
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    handleScroll () {
      if (window.pageYOffset > 500) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    },
    toTop() {
      document.documentElement.scrollTop = 0
    },
    // 切换tab
    handleTabClick(e) {
      this.$router.push(`/careerMatrix/${e.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  width: 1300px;
  margin: 0 auto 0;
  padding-top: 29px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .to-top {
    position: fixed;
    right: 10px;
    bottom: 80px;
    width: 64px;
    height: 64px;
    background: rgba($color: #000000, $alpha: 0.1);
    border-radius: 32px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep .el-tabs {
    .el-tabs__nav-wrap::after, .el-tabs__active-bar {
      background-color: transparent;
    }
    .el-tabs__nav {
      width: 280px;
    }
    .el-tabs__item {
      height: 70px;
      line-height: 70px;
      font-size: 18px;
      font-weight: bold;
      color: #666;
      background-color: #fff;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(155, 185, 222, .3);
      &::before {
        content: '';
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        line-height: 70px;
        background-color: #9BB9DE;
        margin-right: 8px;
      }
    }
    .el-tabs__item.is-active {
      font-size: 20px;
      color: #fff;
      background-image: url('../../assets/image/tab-bg1.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &::before {
        background-color: #FF4E4E;
      }
    }
    .el-tabs__item.is-left {
      text-align: left;
    }
    .box-container {
      width: 877px;
      max-width: 877px;
      background-color: #fff;
      height: auto;
      margin-left: 40px;
      box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
